import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface OAuthConfig {
  providers: string[];
  github_enabled: boolean;
  google_enabled: boolean;
}

export function useOAuthConfig() {
  return useQuery<OAuthConfig>({
    queryKey: ['oauth-config'],
    queryFn: async () => {
      try {
        const response = await api.get('/auth/oauth/config');
        return response.data;
      } catch (_error) {
        // Return empty config if endpoint doesn't exist (backward compatibility)
        return {
          providers: [],
          github_enabled: false,
          google_enabled: false,
        };
      }
    },
    staleTime: Infinity, // Config rarely changes
    retry: false, // Don't retry if OAuth endpoint doesn't exist
  });
}